import de from "vuetify/lib/locale/de"

export default {
  ...de,
  appbar: {
    about: "Über Uns",
    contact: "Kontakt",
    secondopinionFaq: "Häufig gestellte Fragen"
  },
  bottomsheet: {
    imprint: "Impressum",
    generalTerms: "AGB",
    privacyPolicy: "Datenschutzerklärung"
  },
  patient: {
    insuranceNumber: "Versicherungsnummer",
    title: "Titel",
    firstName: "Vorname",
    lastName: "Nachname",
    birthDate: "Geburtsdatum",
    gender: "Geschlecht",
    street: "Straße",
    zipCode: "Postleitzahl",
    city: "Stadt",
    country: "Land",
    telephone: "Telefonnummer"
  },
  specialFieldExceptions: {
    text: `Hiermit bestätige ich, dass keine der rechts genannten Eingriffe bei mir geplant ist.\n
        Der G-BA hat in der Zweitmeinungsrichtlinie einige Eingriffe in die Regelversorgung überführt, in diesen Fällen ist eine Zweitmeinung über die Medexo GmbH nicht möglich.
        Es ist dann eine Vor-Ort-Zweitmeinung vorgesehen.\n
        Informieren Sie sich auf`,
    href: "https://www.116117.de/de/zweitmeinung.php",
    hint: `<ul>
            <li>Knie-Endoprothese: teilweiser oder vollständiger Ersatz des natürlichen Kniegelenks durch eine Prothese</li>
            <li>Hüftgelenkersatz (Hüftprothese, Hüft-TEP oder Oberflächenersatz)</li>
            <li>Schulter-Arthroskopie</li>
            <li>Eingriffe an der Wirbelsäule</li>
            <li>sowie Kathetergestützte elektrophysiologische Herzuntersuchungen und Ablationen am Herzen, Implantation eines Herzschrittmachers oder Defibrillators, Eingriffe an Aortenaneurysmen, Mandeloperationen, Entfernung der Gallenblase</li>
          </ul>`
  },
  consent: {
    button: "Teilnahmererkärung herunterladen",
    pre: "Ich habe die ",
    link: "Teilnahmererkärung",
    post: " heruntergeladen und werde sie ausfüllen und mit meinen Unterlagen hochladen."
  }
}
